import React, { useState } from "react";
import { Checkbox } from "semantic-ui-react";

import useApiService from "../../services/useApiService";
import { getText, initMetadata, formatRiskColumns } from "../../helpers";

export default function PlansComparisonInScope(props) {
  const { plan, risk, isInScope, canUpdate } = props;
  const [{ isLoading }, assignRiskToPlanRequest] = useApiService({ url: `/risks/assign`, method: "post", onSuccess });
  const [isChecked, setIsChecked] = useState(isInScope);

  function onSuccess() {
    setIsChecked(!isChecked);
  }

  function assignRiskToPlan(_, data) {
    // do not toggle if risk is originally `In Scope` and user is not allowed to update
    if (isInScope || !canUpdate) return;

    let metadata = initMetadata();
    metadata = formatRiskColumns(metadata, risk)
    metadata.is_custom = risk.is_custom;

    assignRiskToPlanRequest({
      plan_id: plan.id,
      name: risk.name,
      metadata,
      hidden: !data.checked,
    });
  }

  return (
    <React.Fragment>
      <Checkbox checked={isChecked} label={getText("In Scope")} onClick={assignRiskToPlan} disabled={isLoading || isInScope || !canUpdate} />
      {isLoading && <i className="loading circle notched icon"></i>}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/plans_comparison/plans_comparison_in_scope.js